import {
  AGENT,
  BRANCH,
} from '@/components/FilterBar/constants/filtersConstants';

const getBaseUrl = (filters) => {
  const tokkoBrokerHost = localStorage.getItem('tokkoBrokerHost');
  let url = `${tokkoBrokerHost}/leads/?only_with_perm=true`;
  let withNoParams = true;

  if (filters.filterBy === AGENT && filters.selectedIds.length > 0) {
    url += `&agent=[${filters.selectedIds}]`;
    withNoParams = false;
  }
  if (filters.filterBy === BRANCH && filters.selectedIds.length > 0) {
    url += `&branch_ids=[${filters.selectedIds}]`;
    withNoParams = false;
  }

  if (withNoParams) {
    url += '&company_leads=true';
  }

  return url;
};

export default getBaseUrl;
